import React, { useEffect, useState } from "react";

import "../../components/properties/Properties.css";
import { PuffLoader } from "react-spinners";
import { Route } from 'react-router-dom';
import HeroSearch from "../../components/home/hero/HeroSearch";
import SingleCheapAdvertCard from "../../components/AdvertCard/SingleCheapAdvertCard";
import useEmlakjetProperties from "../../hooks/useEmlakjetProperties";
import Whatsapp1 from "../../components/Whatsapp1/Whatsapp1";
import Call1 from "../../components/Call1/Call1";
const Land = () => {

  const { data, isError, isLoading } = useEmlakjetProperties();
  useEffect(() => {

    
   


    window.scrollTo(0, 0);
  
      

  }, []);

 
  const [filter, setFilter] = useState("");
  if (isError) {
    return (
      <div className="wrapper">
        <span>Error while fetching data</span>
      </div>
    );
  }
  if (isLoading) {
    return (
      <div className="wrapper flexCenter" style={{ height: "60vh" }}>
        <PuffLoader
          height="80"
          width="80"
          radius={1}
          color="#c5955b"
          aria-label="puff-loading"
        />
      </div>
    );
  }
  
  let arsaData = "";
  if (data && Array.isArray(data)) {

    const arsaIndisler = data
    .map((item, index) => ({
      index, // Orijinal indis
      categoryType: item.categoryTypeName,
    }))
    .filter((item) => item.categoryType === "Arsa")
    .map((item) => item.index);
      
  
      arsaData = arsaIndisler.map((index) => data[index]);

  }

  const ScrollToTop = () => {
    window.scrollTo(0, 0);
    return null;
  };
  return (

    

    <div className="wrapper">
      <Route component={ScrollToTop} />
      <Call1 />
      <Whatsapp1 />
      <HeroSearch trade="Arsa" filter={filter} setFilter={setFilter} />
       <div className="px-[3%] md:px-[6%]">
      <div className=" pt-10 pb-16 flex items-start justify-around gap-32 wrapper-alt-div">
 
      <div className="listing-cards-row">
      { arsaData.length === 0 ? <p>Aramada bir ilan bulunamadı</p> : 
      arsaData 
        .filter(
          (property) =>
           
          (property.title && typeof property.title === 'string' && property.title.toLowerCase().includes(filter.toLowerCase())) ||
          property.location?.city?.name?.toLowerCase().includes(filter.toLowerCase()) ||
          property.location?.district?.name?.toLowerCase().includes(filter.toLowerCase()) ||
          property.location?.town?.name?.toLowerCase().includes(filter.toLowerCase()) ||
          property.categoryTypeName?.toLowerCase().includes(filter.toLowerCase ()) ||
          property.tradeTypeName?.toLowerCase().includes(filter.toLowerCase ()) 
        )
        .map((card, i) => {
      
                return <SingleCheapAdvertCard card={card} key={card.id} />;
         
         
        })
    }
            </div>
            
          </div>
        </div>
        
        </div>
  );
};

export default Land;

